import { useEffect, useState } from 'react'
import { DomainType } from '../model'

export const useDomainType = (): DomainType => {
  const [domainType, setDomainType] = useState<DomainType>('syncra')

  useEffect(() => {
    const checkDomain = () => {
      const dataAttribute = document.documentElement.getAttribute('data-domain')
      if (dataAttribute === 'payx') {
        setDomainType('payx')
      } else if (dataAttribute === 'yellowpay') {
        setDomainType('yellowpay')
      } else {
        setDomainType('syncra')
      }
    }
    checkDomain()
    const observer = new MutationObserver(() => {
      checkDomain()
    })

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-domain'],
    })

    return () => observer.disconnect()
  }, [])

  return domainType
}
